import React from 'react';
import { Polygon, InfoWindow } from '@react-google-maps/api';
import { getZoneOptions } from 'helpers/utils';
import { DateFormat } from 'helpers/constants';
import moment from 'moment';

const ViewSelectedPolygon = (props) => {
  const { selectedPolygon, onCloseInfoWindow } = props;

  const polygonOptions = getZoneOptions({
    fillColor: 'yellow',
    editable: false,
    fillOpacity: 0.5,
    zIndex: 1000,
  });

  return (
    <>
      {selectedPolygon?.length > 0 &&
        selectedPolygon.map((polygon) => (
          <Polygon
            key={polygon.id}
            paths={polygon?.zonePolygonJson}
            options={polygonOptions}
          />
        ))}
      {selectedPolygon?.length > 0 &&
        selectedPolygon.map((polygon) => (
          <InfoWindow
            key={polygon.id}
            onCloseClick={() => onCloseInfoWindow(polygon)}
            position={new window.google.maps.LatLng(polygon.lat, polygon.lng)}
            disableAutoPan={true}
          >
            <>
              <div>
                <b>Mağaza Kodu:</b> {polygon?.store?.code}
              </div>
              <div>
                <b>Mağaza:</b> {polygon?.store?.name}
              </div>
              <div>
                <b>Zone Kodu:</b> {polygon?.code}
              </div>
              <div>
                <b>Zone:</b> {polygon?.name}
              </div>
              <div>
                <b>Zone Alanı:</b> {`${polygon?.areaKm || '-'} km²`}
              </div>
              <div>
                <b>Ortalama Sipariş Sayısı:</b> {polygon?.averageOrderCount}
              </div>
              <div>
                <b>Son Güncelleme:</b>{' '}
                {polygon?.modifiedAt
                  ? moment(polygon.modifiedAt).format(
                      DateFormat.WithHourDateFormat,
                    )
                  : ''}
              </div>
            </>
          </InfoWindow>
        ))}
    </>
  );
};

export default ViewSelectedPolygon;
